/**
 * Hook for fetching the recent task status event audit log.
 */

import { useQuery, gql } from "@apollo/client";
import type { TaskExtended, TaskStatus, User } from "@/types";

export interface TaskStatusEvent {
  id: string;
  oldStatus: TaskStatus | null;
  newStatus: TaskStatus;
  actorLabel: string | null;
  createdAt: string;
  actor: User | null;
  task: TaskExtended | null;
  parentTask: TaskExtended | null;
}

export const GET_RECENT_TASK_STATUS_EVENTS = gql`
  query GetRecentTaskStatusEvents($projectIds: [String!]!, $limit: Int) {
    recentTaskStatusEvents(projectIds: $projectIds, limit: $limit) {
      id
      oldStatus
      newStatus
      actorLabel
      createdAt
      actor {
        id
        firstName
        lastName
      }
      task {
        id
        title
        status
        taskType
        parentId
        version
        project {
          id
          name
        }
        section {
          id
          name
          procurementPackage {
            id
            code
            name
          }
        }
        procurementPackage {
          id
          code
          name
        }
      }
      parentTask {
        id
        title
        taskType
        project {
          id
          name
        }
        section {
          id
          name
          procurementPackage {
            id
            code
            name
          }
        }
        procurementPackage {
          id
          code
          name
        }
      }
    }
  }
`;

export function useRecentTaskStatusEvents(projectIds: string[], limit = 6) {
  const { data, loading, refetch } = useQuery<{
    recentTaskStatusEvents: TaskStatusEvent[];
  }>(GET_RECENT_TASK_STATUS_EVENTS, {
    variables: { projectIds, limit },
    skip: projectIds.length === 0,
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-first",
  });

  return {
    events: data?.recentTaskStatusEvents ?? [],
    loading,
    refetch,
  };
}
